/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PreBookResponseMessage } from './PreBookResponseMessage';
import {
    PreBookResponseMessageFromJSON,
    PreBookResponseMessageFromJSONTyped,
    PreBookResponseMessageToJSON,
    PreBookResponseMessageToJSONTyped,
} from './PreBookResponseMessage';
import type { PreBookResponseStatus } from './PreBookResponseStatus';
import {
    PreBookResponseStatusFromJSON,
    PreBookResponseStatusFromJSONTyped,
    PreBookResponseStatusToJSON,
    PreBookResponseStatusToJSONTyped,
} from './PreBookResponseStatus';

/**
 * Response from pre-booking validation
 * @export
 * @interface PreBookResponse
 */
export interface PreBookResponse {
    /**
     * 
     * @type {PreBookResponseStatus}
     * @memberof PreBookResponse
     */
    status: PreBookResponseStatus;
    /**
     * 
     * @type {Array<PreBookResponseMessage>}
     * @memberof PreBookResponse
     */
    message?: Array<PreBookResponseMessage>;
}



/**
 * Check if a given object implements the PreBookResponse interface.
 */
export function instanceOfPreBookResponse(value: object): value is PreBookResponse {
    if (!('status' in value) || value['status'] === undefined) return false;
    return true;
}

export function PreBookResponseFromJSON(json: any): PreBookResponse {
    return PreBookResponseFromJSONTyped(json, false);
}

export function PreBookResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PreBookResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'status': PreBookResponseStatusFromJSON(json['status']),
        'message': json['message'] == null ? undefined : ((json['message'] as Array<any>).map(PreBookResponseMessageFromJSON)),
    };
}

export function PreBookResponseToJSON(json: any): PreBookResponse {
    return PreBookResponseToJSONTyped(json, false);
}

export function PreBookResponseToJSONTyped(value?: PreBookResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'status': PreBookResponseStatusToJSON(value['status']),
        'message': value['message'] == null ? undefined : ((value['message'] as Array<any>).map(PreBookResponseMessageToJSON)),
    };
}

